module.exports = __webpack_public_path__ + "static/media/SaveNUSLogo.58ac3bbb.png";